import './FormActions.scss';

const FormActions = props => (
  <div className="formActions">{props.children}</div>
);

export default FormActions;
